import type {
  FilesFileSchemaWithId,
  FilesFileSchemaWithIdNullable,
  FilesProxySchemaWithId,
} from '@iconik-io/iconik-api/src/services/files';
import type { ContentType } from '@iconik-io/unified-player-core';

import { NEED_TO_GET_AUTH_URL_MARKER } from '../redux/middlewares/entity_ignore_need_auth_url_update';
import { isPdfProxyFormat } from './is_pdf_proxy_format';
import { MEDIA_TYPE_PDF } from './media_type';

// Return proxy URL if present. Return original URL if missing,
// or if content type is PDF (where the proxy is a jpeg).
export function resolveMediaUrl(
  assetProxy: FilesProxySchemaWithId | undefined,
  originalFile:
    | FilesFileSchemaWithId
    | FilesFileSchemaWithIdNullable
    | undefined,
  contentType: ContentType,
) {
  let url = assetProxy?.url;
  const proxyMediaType =
    assetProxy?.format && isPdfProxyFormat(assetProxy?.format)
      ? MEDIA_TYPE_PDF
      : undefined;

  // TODO(FE-7071): Remove once PDFs are rendered from proxies only and
  // originals are not loaded for viewing.
  if (contentType === MEDIA_TYPE_PDF && proxyMediaType !== MEDIA_TYPE_PDF) {
    url = originalFile?.url ?? undefined;
  }

  url = url ?? originalFile?.url ?? undefined;

  if (url?.includes(NEED_TO_GET_AUTH_URL_MARKER)) {
    url = undefined;
  }

  return url;
}
